import AbstractView from 'abstract';
import Vue from 'vue'
import store from 'definitions/store'

export class Main extends AbstractView {
    constructor(domElementId) {
        return super(domElementId);
    }

    init() {
        const SubscribeTwoColumns = () => import(/* webpackChunkName: "snippet-items-subscribe-two-columns" */ 'components/SnippetTemplate/Items/TwoColumns')
        new Vue({
            el: "#" + this.elemId,
            store,
            render: h => h(SubscribeTwoColumns, {props: eval(this.elemId)})
        })
    }
}
